import React from "react"
import { elements } from "caradvise_shared_components"

const { Button } = elements
export default Button
